import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import Demo from "../../sections/demo/Demo"

const pathParamsSchema = z.object({ for: z.string() })

export const Route = createFileRoute("/demo-motorcycle/$for")({
  params: {
    parse: (rawParams) => pathParamsSchema.parse(rawParams),
  },
  component: () => <Demo vehicleType="Motorcycle" />,
})
